import React from 'react';

import { replaceAll } from './../../../../../mol_function';

interface WebgainsDetailsTagProps {
  isBook: boolean;
  productID: number;
  productPrice: string;
  name: string;
}

export default class WebgainsDetailsTag extends React.Component<WebgainsDetailsTagProps> {
  render() {
    let js =
      `window.ntmData=window.ntmData||[];
    window.ntmData.push({
    gdpr: "-1", /* 0 if GDPR does not apply, 1 if GDPR applies */
    gdprConsent: "", /* IAB TCF 2.0 consent string */
    pageType:"product",
    categoryId:"` +
      (this.props.isBook ? '1070545' : '1071055') +
      `",
    productId:"` +
      this.props.productID +
      `",
    productPrice:"` +
      replaceAll(
        this.props.productPrice.substr(0, this.props.productPrice.length - 2),
        ',',
        '.',
      ) +
      `",
    productName:"` +
      this.props.name +
      `"
    });
        `;

    return (
      <script type="text/javascript" dangerouslySetInnerHTML={{ __html: js }} />
    );
  }
}
